export function PriceNumber(str) {
  if (str) {
    str = str.toString();
    var objRegex = new RegExp("(-?[0-9]+)([0-9]{3})");

    while (objRegex.test(str)) {
      str = str.replace(objRegex, "$1,$2");
    }
    return str;
  }
  return 0;
}
export const limitText = (text, limit) => {
  if (text.length > limit) {
    return `${text.substring(0, limit)} ...`;
  } else {
    return text;
  }
};
export function Separate(Number) {
  Number += "";
  Number = Number.replace(",", "");
  var x = Number.split(".");
  var y = x[0];
  var z = x.length > 1 ? "." + x[1] : "";
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(y)) y = y.replace(rgx, "$1" + "," + "$2");
  return y + z;
}

export function toEnglishDigits(str) {

  // convert persian digits [۰۱۲۳۴۵۶۷۸۹]
  var e = '۰'.charCodeAt(0);
  str = str.replace(/[۰-۹]/g, function (t) {
    return t.charCodeAt(0) - e;
  });

  // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
  e = '٠'.charCodeAt(0);
  str = str.replace(/[٠-٩]/g, function (t) {
    return t.charCodeAt(0) - e;
  });
  return str;
}
export const BaseUrl =
  process.env.NODE_ENV === "development"
    ? "https://localhost:7045"
    : "https://amlakto.com";

export function ImageUrl(name) {
  return process.env.NODE_ENV == "development"
    ? "https://localhost:7045/media/" + name
    : "https://amlakto.com/media/" + name;
}